import React, { Component } from 'react'
import Footer from './Footer'
import Navbar from './Navbar'
import AboutUs from './Components/AboutUs'
import News from './Components/News'
import Products from './Components/Products'
import References from './Components/References'
import { Helmet } from "react-helmet";
import Mushroom from './Components/Mushroom'
import MushroomProducts from './Components/MushroomProducts'
import { connect } from 'react-redux'
import FairModal from '../components/FairModal'
import { Catalogs } from './Components/Catalogs'

class HomePage extends Component {

    componentDidMount = () => {
        document.documentElement.lang = "en";
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title data-react-helmet="true">TMS R&D | TMS Train Maintenance Services Inc.</title>
                    <meta http-equiv="content-language" content="en" />
                    <meta
                        name="description"
                        content="TMS R&D | As TMS R&D Team, visit our website now to see our projects and to get to know TMS R&D team | TMS Train Maintenance Services Inc."
                        data-react-helmet="true"
                    />
                    <meta name="keywords" content="TMS R&D" data-react-helmet="true" />

                    <link rel="alternate" hreflang="tr" href="https://www.tmsarge.com/" data-react-helmet="true" />
                    <link rel="alternate" hreflang="en" href="https://www.tmsarge.com/eng" data-react-helmet="true" />
                    <link rel="alternate" hreflang="de" href="https://www.tmsarge.com/de" data-react-helmet="true" />
                    <link rel="alternate" hreflang="x-default" href="https://www.tmsarge.com/" data-react-helmet="true" />
                    <link rel="canonical" href="https://www.tmsarge.com/eng" data-react-helmet="true" />

                </Helmet>
                <Navbar />

                <div className='header-parts' id='homepage'>
                    <div className="header-part">
                        <h3 className="">TMS R&D</h3>
                        <p className="">Innovation, Futuristic, Creative ve Latest Technology</p>
                        <a href="#about-us" className="btn btn-outline-light btn-lg mt-4" type="button">
                            More
                        </a>
                    </div>
                    <div className="header-part">
                        <Mushroom />
                    </div>
                </div>

                <div className="an">
                    <AboutUs />
                    <News />
                </div>

                <Catalogs />

                <MushroomProducts />

                <Products />

                <References />

                <Footer />

                {
                    this.props.isPopupShow && <FairModal />
                }
            </div>

        )
    }
}

const mapStateToProps = (state) => {
    return {
        isPopupShow: state.isPopupShow
    }
};

export default connect(mapStateToProps)(HomePage);